<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.33203 10.0002C2.71078 10.0002 2.40015 10.0002 2.15512 9.89867C1.82842 9.76335 1.56885 9.50378 1.43353 9.17708C1.33203 8.93205 1.33203 8.62142 1.33203 8.00016V3.46683C1.33203 2.72009 1.33203 2.34672 1.47736 2.06151C1.60519 1.81063 1.80916 1.60665 2.06004 1.47882C2.34526 1.3335 2.71863 1.3335 3.46536 1.3335H7.9987C8.61995 1.3335 8.93058 1.3335 9.17561 1.43499C9.50231 1.57032 9.76188 1.82988 9.89721 2.15658C9.9987 2.40161 9.9987 2.71224 9.9987 3.3335M8.13203 14.6668H12.532C13.2788 14.6668 13.6521 14.6668 13.9374 14.5215C14.1882 14.3937 14.3922 14.1897 14.52 13.9388C14.6654 13.6536 14.6654 13.2802 14.6654 12.5335V8.1335C14.6654 7.38676 14.6654 7.01339 14.52 6.72818C14.3922 6.47729 14.1882 6.27332 13.9374 6.14549C13.6521 6.00016 13.2788 6.00016 12.532 6.00016H8.13203C7.3853 6.00016 7.01193 6.00016 6.72671 6.14549C6.47583 6.27332 6.27185 6.47729 6.14402 6.72818C5.9987 7.01339 5.9987 7.38676 5.9987 8.1335V12.5335C5.9987 13.2802 5.9987 13.6536 6.14402 13.9388C6.27185 14.1897 6.47583 14.3937 6.72671 14.5215C7.01193 14.6668 7.3853 14.6668 8.13203 14.6668Z"
      :stroke="color"
      :stroke-width="strokeWidth"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup>
defineProps({
  color: {
    type: String,
    default: "#475467",
  },
  strokeWidth: {
    type: String,
    default: "1.17333",
  },
});
</script>
